const fields = {
  mark: [
    {
      col: 6,
      type: "select",
      name: "mark",
      value: null,
      options: [
        { label: "BMV", value: "bmv" },
        { label: "Mazda", value: "mazda" },
        { label: "Tayota", value: "tayota" }
      ],
      placeholder: "Марка авто"
    },
    {
      col: 6,
      type: "select",
      name: "year",
      value: null,
      options: [
        { label: "2005", value: "2005" },
        { label: "2010", value: "2010" },
        { label: "2013", value: "2013" },
        { label: "2014", value: "2014" },
        { label: "2015", value: "2015" },
        { label: "2016", value: "2016" },
        { label: "2017", value: "2017" },
        { label: "2018", value: "2018" },
        { label: "2019", value: "2019" },
        { label: "2020", value: "2020" }
      ],
      placeholder: "Год выпуска"
    },
    {
      col: 6,
      type: "select",
      name: "model",
      deps: ["mark", "year"],
      value: null,
      options: [],
      placeholder: "Модель"
    },
    {
      col: 6,
      type: "select",
      name: "mod",
      deps: ["mark", "year", "model"],
      value: null,
      options: [],
      placeholder: "Модификация"
    },
    {
      col: 12,
      type: "autofill"
    }
  ],
  params: [
    {
      col: 12,
      type: "sizesSelect",
      name: "tireSize",
      value: {
        versatile: false,
        width: "",
        profile: "",
        widthBack: "",
        profileBack: "",
        diameter: ""
      },
      fields: {
        width: {
          options: [
            { label: "110", value: "110" },
            { label: "120", value: "120" },
            { label: "130", value: "130" },
            { label: "140", value: "140" },
            { label: "150", value: "150" },
            { label: "160", value: "160" },
            { label: "170", value: "170" }
          ],
          placeholder: "Ширина"
        },
        profile: {
          options: [
            { label: "21", value: "21" },
            { label: "22", value: "22" },
            { label: "23", value: "23" },
            { label: "24", value: "24" },
            { label: "25", value: "25" }
          ],
          placeholder: "Профиль"
        },
        widthBack: {
          versatile: true,
          options: [
            { label: "110", value: "110" },
            { label: "120", value: "120" },
            { label: "130", value: "130" },
            { label: "140", value: "140" },
            { label: "150", value: "150" },
            { label: "160", value: "160" },
            { label: "170", value: "170" }
          ],
          placeholder: "Ширина"
        },
        profileBack: {
          versatile: true,
          options: [
            { label: "21", value: "21" },
            { label: "22", value: "22" },
            { label: "23", value: "23" },
            { label: "24", value: "24" },
            { label: "25", value: "25" }
          ],
          placeholder: "Профиль"
        },
        diameter: {
          options: [
            { label: "12", value: "12" },
            { label: "13", value: "13" },
            { label: "14", value: "14" },
            { label: "15", value: "15" },
            { label: "16", value: "16" }
          ],
          placeholder: "Диаметр"
        }
      }
    },
    {
      col: 4,
      type: "select",
      name: "season",
      value: null,
      multiple: true,
      options: [
        { label: "Зима", value: "winter" },
        { label: "Лето", value: "summer" }
      ],
      placeholder: "Сезон"
    },
    {
      col: 4,
      type: "select",
      name: "vendor",
      value: null,
      multiple: true,
      options: [
        { label: "Производитель 1", value: "1" },
        { label: "Производитель 2", value: "2" },
        { label: "Производитель 3", value: "3" },
        { label: "Производитель 4", value: "4" }
      ],
      placeholder: "Производитель"
    },
    {
      col: 4,
      type: "select",
      name: "tireClass",
      value: null,
      options: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" }
      ],
      placeholder: "Класс резины"
    },
    {
      col: 4,
      type: "checkbox",
      name: "spikes",
      value: false,
      label: "Класс резины"
    },
    {
      col: 4,
      type: "checkbox",
      name: "runflat",
      value: false,
      label: "RunFlat"
    }
  ],
  code: [
    {
      col: 12,
      type: "input",
      name: "code",
      value: null,
      placeholder: "Укажите код товара"
    }
  ]
};

export const tabs = {
  name: "tab",
  value: "tires",
  list: [
    {
      name: "tires",
      title: "Подобрать шины",

      childs: [
        {
          value: "cars",
          name: "cat",
          list: [
            {
              name: "cars",
              title: "Легковые",
              icon: { width: 62, height: 24 },

              childs: [
                {
                  value: "model",
                  name: "type",
                  list: [
                    {
                      name: "model",
                      title: "По марке авто",
                      childs: JSON.parse(JSON.stringify(fields.mark))
                    },
                    {
                      name: "params",
                      title: "По параметрам",
                      childs: JSON.parse(JSON.stringify(fields.params))
                    },
                    {
                      name: "code",
                      title: "По коду товара",
                      childs: JSON.parse(JSON.stringify(fields.code))
                    }
                  ]
                }
              ]
            },
            {
              name: "cargo",
              title: "Грузовые",
              icon: { width: 82, height: 37 }
            },
            { name: "agro", title: "Сельхоз", icon: { width: 55, height: 41 } },
            {
              name: "moto",
              title: "Мототехника",
              icon: { width: 56, height: 30 }
            }
          ]
        }
      ]
    },
    {
      name: "disks",
      title: "Подобрать диски",

      childs: [
        {
          value: "model",
          name: "type",
          list: [
            {
              name: "model",
              title: "По марке авто",
              childs: JSON.parse(JSON.stringify(fields.mark))
            },
            {
              name: "params",
              title: "По параметрам",
              childs: JSON.parse(JSON.stringify(fields.params))
            },
            {
              name: "code",
              title: "По коду товара",
              childs: JSON.parse(JSON.stringify(fields.code))
            }
          ]
        }
      ]
    }
  ]
};

export const user = {
  auth: true,
  data: {
    mark: "bmv",
    year: "2010",
    model: "1",
    mod: "2"
  }
};
